module.exports = __webpack_public_path__ + "img/star-ai-card@3x.36f10eaf.png";